import { axiosInstance as request } from '@api/rest.service'

const api = '/auth'

/**
 * @description POST /auth/login
 * @returns {AxiosPromise<any>}
 */
export const LOGIN = payload => request.post(`${api}/login`, payload)

/**
 * @description POST /auth/forgot
 * @returns {AxiosPromise<any>}
 */
export const FORGOT = () => request.post(`${api}/forgot`)

/**
 * @description POST /auth/reset
 * @returns {AxiosPromise<any>}
 */
export const RESET = () => request.post(`${api}/reset`)

/**
 * @description POST /auth/logout
 * @returns {AxiosPromise<any>}
 */
export const LOGOUT = () => request.post(`${api}/logout`)
